module.exports = __webpack_public_path__ + "static/img/newanli-15.1b014ac9.jpg";